import React, { FunctionComponent, useEffect, useState } from 'react';

// Libs
import classnames from 'classnames';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Components
import Page from '@Components/Utils/Page';
import ComponentLazy from '@Components/Utils/Lazy/Component';
import PlaceholderView from '@Components/UI/PlaceholderView';

// Types
import { NextSeoProps } from 'next-seo';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { getListEClinic, getMedicalSpecialities } from 'src/apis/graphql/api';

// Styles
import styles from './Listing.module.scss';
import { SupportButton } from '@Components/Layout/Components/SupportButton';

const Listing: FunctionComponent<InferGetServerSidePropsType<typeof getServerSideProps>> = () => {
  const { deviceType } = useViewDetected();
  const [dataListing, setDataListing] = useState<Array<Object>>([]);
  const [medicalSpecialities, setMedicalSpecialities] = useState<any>([]);

  const isMobile = deviceType !== 'desktop';

  const wrapperClassName = classnames([styles.wrapper, { [styles.mobile]: isMobile }]);

  useEffect(() => {
    getListEClinic({})
      .then(res => {
        if (res.code === 1000) {
          setDataListing(res?.data?.eClinics ?? [])
        } else {
          setDataListing([])
        }
      })
      .catch(err => console.log('error getListEClinic', err))

    getMedicalSpecialities({}).then(res => {
      if (res.code === 1000) {
        setMedicalSpecialities(res?.data?.medicalSpecialities ?? [])
      } else {
        setMedicalSpecialities([])
      }
    }).catch(err => console.log('error getMedicalSpecialities', err))
  }, [])

  return (
    <Page className={wrapperClassName}>
      <ComponentLazy
        className={styles.costing}
        dynamic={() => import('@Pages/gioi-thieu/danh-sach-phong-kham/Components/Choice')}
        placeholder={() => <PlaceholderView mobileHeight={744} tabletHeight={744} desktopHeight={882} />}
        data={dataListing}
        setDataListing={setDataListing}
        medicalSpecialities={(medicalSpecialities ?? []).map(item => {
          return {
            label: item?.name,
            value: item?.medicalSpecialtyId
          }
        })}
      />
      <SupportButton />
    </Page>
  );
};

export default Listing;

export const getServerSideProps: GetServerSideProps = async () => {
  const title = 'eDoctor: Giới thiệu phòng tư vấn';
  const seo: NextSeoProps = {
    title,
    openGraph: {
      title,
      type: 'website',
    },
  };

  return {
    props: {
      seo,
    },
  };
};
